module.exports = __webpack_public_path__ + "static/img/betask.c457625.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/betask.png
// module id = 5FrH
// module chunks = 3